import MuiTextField from '@material-ui/core/TextField';
import { fieldToTextField, TextFieldProps } from 'formik-material-ui';
import * as React from 'react';
import { useIntl } from 'react-intl';
import { convertToFloat } from '../../utils';

export default function NumberFormatTextField(props: TextFieldProps) {
  const { formatNumber } = useIntl();
  let onChangeFromComponent = null;
  if (typeof props.onChange === 'function') {
    onChangeFromComponent = props.onChange;
  }
  const {
    form: { setFieldValue },
  } = props;

  const onChange = React.useCallback(
    (event) => {
      const { value } = event.target;
      let formattedNumber = value.split('.');

      if (formattedNumber[0][0] === '$')
        formattedNumber[0] = formattedNumber[0].substring(1);
      if (formattedNumber.length === 1) {
        formattedNumber = convertToFloat(formattedNumber[0]);
      } else {
        formattedNumber[0] = convertToFloat(formattedNumber[0]);
        if (formattedNumber[0] === 'NaN') formattedNumber = 'NaN';
        else {
          formattedNumber[1] = formattedNumber[1].toString();
          formattedNumber[1] = formattedNumber[1].substring(0, 2);
          formattedNumber = `${formattedNumber[0]}.${formattedNumber[1]}`;
        }
      }
      const isValidNumber = !isNaN(formattedNumber);
      setFieldValue(
        event.target.name,
        isValidNumber ? String(formattedNumber) : value,
      );
      if (isValidNumber && onChangeFromComponent) onChangeFromComponent(event);
    },
    // eslint-disable-next-line
    [setFieldValue, formatNumber, onChangeFromComponent],
  );

  return (
    <MuiTextField
      {...fieldToTextField(props)}
      onChange={onChange}
      inputProps={{ inputMode: 'decimal' }}
    />
  );
}
